import type PlayClient from '@empathybroker/tsclient-play'
import type { Instance } from '@empathybroker/tsclient-play/dist/models/instance/instance'
import type { AccessTokenProvider } from '@empathyco/playboard-core-domain'
import type { Store } from 'vuex/types'
import type { BrowsePayload, BrowseResponse, BrowseService } from './types/browse-service'
import { inject, injectable } from 'inversify'
import { TYPES } from '../../../config/inversify.types'
import { CONFIG_CONSTS } from '../../../store/config/config.consts'
import { PlayClientUtils } from '../../../utils/play-client.utils'

@injectable()
export class PlatformBrowseService implements BrowseService {
  constructor(
    @inject(TYPES.PlayClient) private playClientFactory: () => PlayClient,
    @inject(TYPES.AccessTokenProvider) private accessTokenProvider: AccessTokenProvider,
    @inject(TYPES.Store) private store: Store<unknown>,
  ) {}

  async browse(payload: BrowsePayload): Promise<BrowseResponse> {
    const authToken = await this.accessTokenProvider()
    const currentInstance: Instance =
      this.store.getters[`${CONFIG_CONSTS.moduleName}/${CONFIG_CONSTS.getters.currentInstance}`]
    const { params, page, resultMappingInfo } = PlayClientUtils.buildBrowseParameters({
      filters: payload.filters,
      instance: currentInstance,
      params: payload.params || {},
      pagination: payload.pagination,
    })

    return await this.playClientFactory().browse(
      authToken,
      payload.attribute,
      params,
      page,
      payload.debug,
      resultMappingInfo,
    )
  }
}
